import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
import { computed } from 'vue';
import HeaderView from '@/components/HeaderView.vue';

// 初始化时判断原生路径中是否包含 'cretaceous'

export default {
  __name: 'HomeView',
  setup(__props) {
    const isCretaceousMode = window.location.pathname.includes('/cretaceous');

    // 动态计算第一张图片的路径
    const img1Src = computed(() => {
      if (isCretaceousMode) {
        // 👇 修改点 2：后缀修正为 .jpg
        return require('@/images/img_7.jpg');
      }
      // 否则加载常规默认图片
      return require('@/images/img_1.jpg');
    });

    // 👇 修改点 3：由于第二张图现在只在常规模式下显示，直接返回 img_2.jpg 即可
    const img2Src = computed(() => {
      return require('@/images/img_2.jpg');
    });

    // 以下是你原来注释掉的代码，原样保留
    // onMounted(async () => {
    //   try {
    //     await axios.post('http://localhost:8080/api/stats/view')
    //   } catch (error) {
    //     console.error('记录访问量失败:', error)
    //   }
    // })

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(HeaderView), _createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("p", {
        class: "introduction"
      }, [_createTextVNode(" Welcome to the "), _createElementVNode("span", {
        style: {
          "font-weight": "bold"
        }
      }, "Cyclostratigraphy Database,"), _createTextVNode(" your comprehensive platform for exploring the tast of cyclostratigraphy from Precambrian to Mesozoic! ")], -1)), _createElementVNode("img", {
        src: img1Src.value,
        style: {
          "width": "95%",
          "margin-bottom": "30px",
          "margin-top": "10px"
        },
        alt: "Home Image 1"
      }, null, 8, _hoisted_3), !_unref(isCretaceousMode) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: img2Src.value,
        style: {
          "width": "95%"
        },
        alt: "Home Image 2"
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true)])]);
    };
  }
};